import { Lightning, ShieldCheck, Truck } from "@phosphor-icons/react";
import { Reveal } from "@/components/site/Reveal";

const CARDS = [
  {
    num: "01",
    tag: "Speed",
    icon: Lightning,
    title: "30-Minute ETA",
    body: "Direct owner dispatch means no call centers and faster arrival times. When you call, you reach the driver — not a queue.",
  },
  {
    num: "02",
    tag: "Safety",
    icon: ShieldCheck,
    title: "Damage-Free Flatbed",
    body: "Specialized low-clearance equipment perfect for luxury, exotic, and standard vehicles. Your car arrives exactly as it left.",
  },
  {
    num: "03",
    tag: "B2B Priority",
    icon: Truck,
    title: "Commercial & Fleet Partners",
    body: "Priority emergency towing and auction transport for local repair shops and dealerships. Built for businesses that can't wait.",
  },
];

export const ValueGrid = () => (
  <section
    id="why"
    data-testid="value-grid-section"
    className="relative z-10 bg-[var(--tt-black)] px-5 md:px-10 lg:px-16 py-24 md:py-32"
  >
    <Reveal>
      <div className="flex items-end justify-between flex-wrap gap-6 mb-14 md:mb-20">
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-[var(--tt-green)] mb-4">
            / The Solo-Operator Advantage
          </p>
          <h2 className="font-display uppercase text-4xl md:text-6xl leading-[0.9] tracking-tighter max-w-3xl">
            One owner. One truck. <br />
            <span className="text-zinc-500">Zero middlemen.</span>
          </h2>
        </div>
        <p className="max-w-xs text-zinc-400 text-sm md:text-base leading-relaxed">
          Big fleets route you through dispatchers. We don't. Every call is answered by the person
          who does the work.
        </p>
      </div>
    </Reveal>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
      {CARDS.map((card, i) => {
        const Icon = card.icon;
        return (
          <Reveal key={card.num} delay={i * 0.12}>
            <div
              data-testid={`value-card-${card.num}`}
              className="group relative h-full bg-[var(--tt-surface)] border border-white/5 p-8 md:p-9 overflow-hidden hover:border-[var(--tt-green)]/60 transition-colors duration-500 tt-clip-card"
            >
              <div
                className="pointer-events-none absolute -top-24 -right-24 h-52 w-52 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-2xl"
                style={{ background: "radial-gradient(circle, rgba(57,255,20,0.28), transparent 70%)" }}
              />
              <div className="relative z-10 flex items-center justify-between mb-10">
                <span className="font-display text-6xl md:text-7xl text-white/[0.06] group-hover:text-[var(--tt-green)]/20 transition-colors duration-500 leading-none">
                  {card.num}
                </span>
                <Icon
                  weight="fill"
                  className="h-9 w-9 text-zinc-600 group-hover:text-[var(--tt-green)] group-hover:tt-green-glow transition-colors duration-500"
                />
              </div>
              <div className="relative z-10">
                <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[var(--tt-green)] mb-3">
                  {card.tag}
                </p>
                <h3 className="font-display uppercase text-2xl md:text-3xl tracking-tight mb-4 leading-none">
                  {card.title}
                </h3>
                <p className="text-zinc-400 text-sm md:text-base leading-relaxed">{card.body}</p>
              </div>
            </div>
          </Reveal>
        );
      })}
    </div>
  </section>
);
